/* eslint-disable @next/next/no-img-element */
import { DownloadGuide } from "@unisearch/common";
import GoogleAdTop from "@unisearch/common/google_ad_top";
import { getAssets } from "@unisearch/helpers";
import { readingTime, remove_tags } from "@unisearch/helpers/utils";
import Image from "next/legacy/image";
import Link from "next/link";
import PageInfo from "../common/page_info";
import styles from "./study_banner.module.scss";

export const StudyBanner = ({ pageData, name = "", linkType }) => {
  const arr = ["united-states", "united-kingdom"];

  return (
    <section className={`${styles.section_study_banner} !pt-6`}>
      <div className="container">
        <GoogleAdTop className={"lg:mb-[60px]"} />
        <div className={styles.hero_wrapper}>
          <div className={styles.hero_content}>
            <p className={styles.sub_heading}>
              <span className="bold">{pageData?.referenceColumnName}</span>{" "}
              {(pageData?.pageContent && readingTime(pageData.pageContent)) ||
                1}{" "}
              min read
            </p>
            <h1 className={styles.heading}>{pageData?.pageTitle}</h1>

            {pageData?.pageShortDescription && (
              <div className={styles.description}>
                {remove_tags(pageData.pageShortDescription)}
              </div>
            )}

            {/* breadcrumbs */}
            <div className={styles.breadcrumbs}>
              <Link legacyBehavior href="/">
                <a>
                  <span>Home</span>
                </a>
              </Link>
              {" - "}
              <Link legacyBehavior href={`/${linkType}/${name}`}>
                <a>
                  <span>
                    {linkType}{" "}
                    {linkType === "study"
                      ? `in ${arr.includes(name) ? "the" : ""}`
                      : ""}{" "}
                    {pageData?.referenceColumnName}
                  </span>
                </a>
              </Link>
              {" - "}
              <p className={styles.active}>{pageData?.pageTitle}</p>
            </div>
            {/* Short info */}
            <div className={styles.short_info_desktop_}>
              <PageInfo
                pageType="page"
                id={pageData?.pageId}
                data={pageData}
                authorName={pageData?.authorName}
                authorImage={pageData?.authorProfileImage}
              />
            </div>
            {pageData && pageData?.guidepdf && (
              <div className={styles.button_wrapper}>
                <DownloadGuide
                  customClasses={{ root: "btn-bg" }}
                  fileSrc={pageData?.guidepdf?.src}
                  documentId={parseInt(pageData?.guidepdf?.mediaManagerId)}
                  documentType={linkType == "study" ? "countryguide" : linkType}
                />
              </div>
            )}
          </div>
          <div className={styles.image_wrapper}>
            <Image
              layout="responsive"
              width={500}
              height={450}
              blurDataURL={getAssets(
                "assets/images/study/country_placeholder.webp"
              )}
              placeholder="blur"
              className={styles.featured_image}
              src={
                pageData?.featureImage?.src ||
                getAssets("assets/images/study/country_placeholder.webp")
              }
              alt={pageData?.featureImage?.alt}
            />
            <div className={styles.bg_soft}></div>
            <div className={styles.oval_square}>
              <Image
                width={150}
                height={150}
                src={getAssets("assets/images/study/ornament.webp")}
                alt="Ornament"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudyBanner;
